import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import WellnessInput from '../WellnessInput';
import MobileWellnessWizard from './MobileWellnessWizard';
import MobileRPEWizard from './MobileRPEWizard';

const BACK_BTN = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '8px 14px',
  borderRadius: 10,
  border: '1px solid var(--border-strong)',
  background: 'var(--bg-card)',
  color: 'var(--text-secondary)',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
  marginBottom: 20,
};

function yesterdayStr() {
  const d = new Date(); d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default function PlayerWellness({ playerRecord, defaultTab = 'wellness', sessionType = 'pitch', isMobile }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // ?date= is only set by the late-game "Fill in game RPE" button (see lateMatchRpe in
  // PlayerDataContext) and only ever honoured for yesterday's pitch RPE — not a general
  // backfill route.
  const requestedDate = searchParams.get('date');
  const rpeDate = defaultTab === 'rpe' && sessionType === 'pitch' && requestedDate === yesterdayStr() ? requestedDate : null;

  if (isMobile && defaultTab === 'rpe') {
    return <MobileRPEWizard playerRecord={playerRecord} sessionType={sessionType} date={rpeDate} />;
  }
  if (isMobile) {
    return <MobileWellnessWizard playerRecord={playerRecord} />;
  }

  return (
    <div style={{ padding: 16 }}>
      <button onClick={() => navigate('/player/forms')} style={BACK_BTN}>
        ← Back
      </button>
      <WellnessInput
        playerOverride={playerRecord}
        defaultTab={defaultTab}
        sessionType={sessionType}
        initialDate={rpeDate}
        hideTabs={['history']}
      />
    </div>
  );
}
